// extracted by mini-css-extract-plugin
export var actionButton = "_j0-t";
export var buttonContainer = "_j0-0";
export var buttonContainer2 = "_j0-1";
export var buttonSection = "_j0-2";
export var details = "_j0-3";
export var dropdownItem = "_j0-5";
export var dropdownItemsContainer = "_j0-4";
export var fileInput = "_j0-r";
export var headerButton = "_j0-6";
export var icon = "_j0-7";
export var input = "_j0-8";
export var macroListItem = "_j0-9";
export var mainContent = "_j0-a";
export var microText = "_j0-b";
export var modal = "_j0-w";
export var optionsButton = "_j0-c";
export var paperclip = "_j0-s";
export var pillContent = "_j0-d";
export var preview = "_j0-e";
export var preview2 = "_j0-f";
export var quillEditor = "_j0-q";
export var selectedMacro = "_j0-g";
export var sidebar = "_j0-h";
export var sidebarHeader = "_j0-j";
export var sidebarList = "_j0-i";
export var sidebarListItem = "_j0-k";
export var sidebarSearch = "_j0-l";
export var snoozeDurationWrapper = "_j0-v";
export var statusPillContainer = "_j0-m";
export var tagsContainer = "_j0-n";
export var unselectedMacro = "_j0-o";
export var variable = "_j0-u";
export var wrapper = "_j0-p";